import { YieldFetcher } from '../../types'

const HLP_URL = 'https://api-ui.hyperliquid.xyz/info'
const HWHLP_URL = 'https://api.hyperwavefi.xyz/stats/latest?asset=hwhlp_999'

const hlp = 'Wrapped HLP::WHLP'
const hwhlp = 'Hyperwave HLP::hwHLP'

export const hlpFetcher: YieldFetcher = {
  label: 'HLP',
  fetch: async () => {
    const res = await fetch(HLP_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        type: 'vaultDetails',
        vaultAddress: '0xdfc24b077bc1425ad1dea75bcb6f8158e10df303',
      }),
    }).then((r) => r.json())
    let calculated: number
    try {
      const p = res.portfolio[0][1]
      const val = p.accountValueHistory[p.accountValueHistory.length - 1][1]
      const pnl = p.pnlHistory[p.pnlHistory.length - 1][1]
      calculated = (pnl / val) * 100
    } catch {
      calculated = (res?.apr ?? 0) * 100
    }
    return { [hlp]: calculated }
  },
}

export const hwhlpFetcher: YieldFetcher = {
  label: 'HWHLP',
  fetch: async () => {
    const res = (await fetch(HWHLP_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())) as any
    return { [hwhlp]: Number(res.data?.apr_1d ?? 0) }
  },
}
